var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3268.6,
    height: 3304.56,
    viewBox: "0 0 3268.6 3304.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 0 0 L 3268.601562 0 L 3268.601562 3304.558594 L 0 3304.558594 Z M 0 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 2642.890625 2182.269531 L 2927.210938 2183.558594 C 2927.019531 2118.101562 2929.519531 1591.5 2924.371094 1573.738281 C 2904.878906 1506.539062 2855.839844 1462.46875 2784.300781 1459.800781 L 2527.109375 1459.789062 L 2527.109375 1772.980469 C 2568.160156 1773 2642.910156 1761.550781 2642.910156 1823.058594 L 2642.910156 2182.269531 Z M 336.839844 405.171875 L 336.839844 1617.070312 C 336.839844 1697.960938 402.660156 1763.78125 483.585938 1763.78125 L 998.777344 1763.78125 L 998.777344 1459.789062 L 680.351562 1459.789062 C 652.679688 1459.789062 630.277344 1437.378906 630.277344 1409.710938 L 630.277344 405.171875 Z M 2401.640625 3204.460938 L 3168.460938 3204.460938 L 3168.460938 2999.570312 L 2401.640625 2999.570312 Z M 100.136719 305.03125 L 866.953125 305.03125 L 866.953125 100.148438 L 100.136719 100.148438 Z M 1233.339844 1309.699219 C 1159.691406 1309.699219 1098.941406 1371.871094 1098.941406 1444.078125 C 1098.941406 1507.890625 1094.019531 1755.960938 1101.121094 1800.191406 C 1127.429688 1947.460938 1343.21875 1945.441406 1366.019531 1797.21875 L 1366.03125 1797.21875 C 1372.128906 1756.800781 1368.53125 1440.390625 1366.320312 1425.011719 C 1356.910156 1359.269531 1299.710938 1309.699219 1233.339844 1309.699219 Z M 2292.53125 1316 C 2219.171875 1316 2158.109375 1377.21875 2158.109375 1450.371094 C 2158.109375 1560.039062 2152.328125 1711.101562 2162.050781 1814.578125 C 2166.828125 1865.378906 2232.960938 1916.78125 2292.53125 1916.78125 C 2365.421875 1916.78125 2426.929688 1854.738281 2426.929688 1782.410156 C 2426.929688 1721.050781 2431.53125 1472.550781 2425.570312 1431.398438 C 2416.078125 1365.578125 2358.929688 1316 2292.53125 1316 Z M 2057.960938 1761.679688 L 2057.960938 1458.480469 L 1467.871094 1458.480469 L 1467.871094 1761.679688 Z M 2927.210938 2652.660156 L 2642.890625 2651.371094 L 2642.890625 2899.390625 L 2927.210938 2899.390625 Z M 2950.429688 2552.640625 Z M 2602.621094 2550.121094 C 2682.339844 2550.121094 2925.421875 2558.339844 2970.96875 2551.171875 C 3135.390625 2525.21875 3113.460938 2284.441406 2951.609375 2283.890625 C 2889.25 2283.679688 2647.71875 2278.160156 2605.691406 2282.96875 C 2446.050781 2301.25 2445.449219 2530.519531 2602.621094 2550.121094 Z M 2542.738281 2899.390625 L 2542.738281 2638.578125 C 2330.589844 2566.109375 2335.53125 2266.558594 2542.789062 2194.960938 L 2542.808594 1873.128906 L 2508.539062 1873.128906 C 2423.941406 2071.21875 2143.761719 2059.980469 2071.878906 1861.828125 L 1451.609375 1861.828125 C 1374.75 2057.558594 1094.660156 2058.769531 1015.921875 1863.929688 L 483.585938 1863.929688 C 347.464844 1863.929688 236.703125 1753.199219 236.703125 1617.078125 L 236.703125 405.171875 L 50.0625 405.171875 C 22.40625 405.171875 0 382.761719 0 355.109375 L 0 50.070312 C 0 22.398438 22.40625 0 50.0625 0 L 917.027344 0 C 944.6875 0 967.089844 22.398438 967.089844 50.070312 L 967.089844 355.109375 C 967.117188 382.78125 944.699219 405.171875 917.042969 405.171875 L 730.4375 405.171875 L 730.4375 1359.648438 L 1014.628906 1359.648438 C 1091.5 1162.191406 1373.511719 1161.398438 1451.539062 1358.339844 L 2076.890625 1358.339844 C 2158.210938 1169.578125 2428.769531 1170.398438 2508.75 1359.898438 C 2557.578125 1360.28125 2806.390625 1357.511719 2833.890625 1364.601562 C 2949.191406 1394.320312 3022.789062 1480.640625 3027.378906 1601.910156 L 3027.378906 2196.480469 C 3236.640625 2268.289062 3236.378906 2568.109375 3027.328125 2639.96875 L 3027.328125 2899.390625 L 3218.519531 2899.390625 C 3246.199219 2899.390625 3268.601562 2921.800781 3268.601562 2949.480469 L 3268.601562 3254.5 C 3268.601562 3282.179688 3246.199219 3304.558594 3218.519531 3304.558594 L 2351.578125 3304.558594 C 2323.921875 3304.558594 2301.511719 3282.160156 2301.511719 3254.5 L 2301.511719 2949.480469 C 2301.511719 2921.800781 2323.921875 2899.390625 2351.578125 2899.390625 L 2542.738281 2899.390625 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-0",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(3268.6, 0, 0, 3268.6, 0, 1652.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(11.372375%, 37.254333%, 37.646484%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "rgb(11.326599%, 37.156677%, 37.547302%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "rgb(11.238098%, 36.964417%, 37.35199%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "rgb(11.149597%, 36.77063%, 37.155151%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "rgb(11.061096%, 36.578369%, 36.959839%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "rgb(10.971069%, 36.384583%, 36.763%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "rgb(10.882568%, 36.192322%, 36.567688%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "rgb(10.794067%, 35.998535%, 36.37085%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(10.705566%, 35.806274%, 36.175537%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "rgb(10.617065%, 35.612488%, 35.978699%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "rgb(10.527039%, 35.420227%, 35.783386%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "rgb(10.438538%, 35.22644%, 35.586548%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(10.350037%, 35.03418%, 35.391235%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "rgb(10.261536%, 34.840393%, 35.194397%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "rgb(10.171509%, 34.648132%, 34.999084%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "rgb(10.083008%, 34.454346%, 34.802246%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(9.994507%, 34.262085%, 34.606934%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "rgb(9.906006%, 34.068298%, 34.410095%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "rgb(9.815979%, 33.876038%, 34.214783%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "rgb(9.727478%, 33.682251%, 34.017944%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(9.638977%, 33.48999%, 33.822632%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "rgb(9.550476%, 33.296204%, 33.625793%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "rgb(9.461975%, 33.103943%, 33.430481%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "rgb(9.371948%, 32.911682%, 33.233643%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(9.283447%, 32.717896%, 33.03833%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "rgb(9.194946%, 32.525635%, 32.841492%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "rgb(9.106445%, 32.331848%, 32.646179%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "rgb(9.016418%, 32.139587%, 32.449341%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(8.927917%, 31.945801%, 32.254028%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "rgb(8.839417%, 31.75354%, 32.05719%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "rgb(8.750916%, 31.559753%, 31.861877%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "rgb(8.662415%, 31.367493%, 31.665039%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(8.572388%, 31.173706%, 31.469727%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "rgb(8.483887%, 30.981445%, 31.272888%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "rgb(8.395386%, 30.787659%, 31.077576%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "rgb(8.306885%, 30.595398%, 30.880737%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(8.216858%, 30.401611%, 30.685425%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "rgb(8.128357%, 30.209351%, 30.488586%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(8.039856%, 30.015564%, 30.293274%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "rgb(7.951355%, 29.823303%, 30.096436%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(7.861328%, 29.629517%, 29.901123%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "rgb(7.772827%, 29.437256%, 29.704285%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "rgb(7.684326%, 29.243469%, 29.508972%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "rgb(7.595825%, 29.051208%, 29.312134%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(7.507324%, 28.857422%, 29.116821%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "rgb(7.417297%, 28.665161%, 28.919983%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "rgb(7.328796%, 28.471375%, 28.72467%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "rgb(7.240295%, 28.279114%, 28.527832%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(7.151794%, 28.085327%, 28.33252%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "rgb(7.061768%, 27.893066%, 28.135681%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "rgb(6.973267%, 27.69928%, 27.940369%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "rgb(6.884766%, 27.507019%, 27.74353%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(6.796265%, 27.313232%, 27.548218%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "rgb(6.707764%, 27.120972%, 27.351379%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "rgb(6.617737%, 26.927185%, 27.156067%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "rgb(6.529236%, 26.734924%, 26.959229%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(6.440735%, 26.541138%, 26.763916%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "rgb(6.352234%, 26.348877%, 26.567078%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "rgb(6.262207%, 26.15509%, 26.371765%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "rgb(6.173706%, 25.96283%, 26.174927%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(6.085205%, 25.769043%, 25.979614%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "rgb(5.996704%, 25.576782%, 25.782776%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(5.906677%, 25.382996%, 25.587463%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "rgb(5.818176%, 25.190735%, 25.390625%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(5.729675%, 24.996948%, 25.195312%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "rgb(5.641174%, 24.804688%, 24.998474%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(5.552673%, 24.610901%, 24.803162%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "rgb(5.462646%, 24.41864%, 24.606323%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(5.374146%, 24.224854%, 24.411011%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "rgb(5.285645%, 24.032593%, 24.214172%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(5.197144%, 23.838806%, 24.01886%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "rgb(5.107117%, 23.646545%, 23.822021%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(5.018616%, 23.452759%, 23.626709%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "rgb(4.930115%, 23.260498%, 23.429871%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(4.841614%, 23.066711%, 23.234558%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "rgb(4.753113%, 22.874451%, 23.03772%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(4.663086%, 22.680664%, 22.842407%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "rgb(4.574585%, 22.488403%, 22.645569%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(4.486084%, 22.294617%, 22.450256%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "rgb(4.397583%, 22.102356%, 22.253418%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(4.307556%, 21.908569%, 22.058105%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "rgb(4.219055%, 21.716309%, 21.861267%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(4.130554%, 21.522522%, 21.665955%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "rgb(4.042053%, 21.330261%, 21.469116%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(3.952026%, 21.136475%, 21.273804%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "rgb(3.863525%, 20.944214%, 21.076965%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(3.775024%, 20.750427%, 20.881653%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "rgb(3.686523%, 20.558167%, 20.684814%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(3.598022%, 20.36438%, 20.489502%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "rgb(3.507996%, 20.172119%, 20.292664%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(3.419495%, 19.978333%, 20.097351%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "rgb(3.330994%, 19.786072%, 19.900513%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(3.242493%, 19.592285%, 19.7052%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "rgb(3.152466%, 19.400024%, 19.508362%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(3.063965%, 19.206238%, 19.313049%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "rgb(2.975464%, 19.013977%, 19.116211%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(2.886963%, 18.82019%, 18.920898%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "rgb(2.798462%, 18.62793%, 18.72406%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(2.708435%, 18.434143%, 18.528748%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "rgb(2.619934%, 18.241882%, 18.331909%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(2.531433%, 18.048096%, 18.136597%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "rgb(2.442932%, 17.855835%, 17.939758%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(2.352905%, 17.662048%, 17.744446%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "rgb(2.264404%, 17.469788%, 17.547607%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(2.175903%, 17.276001%, 17.352295%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "rgb(2.087402%, 17.08374%, 17.155457%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(1.997375%, 16.889954%, 16.960144%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "rgb(1.908875%, 16.697693%, 16.763306%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(1.820374%, 16.503906%, 16.567993%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "rgb(1.731873%, 16.311646%, 16.371155%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(1.643372%, 16.119385%, 16.175842%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "rgb(1.553345%, 15.925598%, 15.979004%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(1.464844%, 15.733337%, 15.783691%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "rgb(1.376343%, 15.539551%, 15.586853%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(1.287842%, 15.34729%, 15.391541%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "rgb(1.197815%, 15.153503%, 15.194702%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(1.109314%, 14.961243%, 14.99939%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "rgb(1.020813%, 14.767456%, 14.802551%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "rgb(0.932312%, 14.575195%, 14.607239%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "rgb(0.843811%, 14.381409%, 14.4104%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(0.753784%, 14.189148%, 14.215088%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "rgb(0.665283%, 13.995361%, 14.01825%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "rgb(0.576782%, 13.803101%, 13.822937%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "rgb(0.488281%, 13.609314%, 13.626099%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "rgb(0.398254%, 13.417053%, 13.430786%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "rgb(0.309753%, 13.223267%, 13.233948%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "rgb(0.221252%, 13.031006%, 13.038635%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "rgb(0.132751%, 12.837219%, 12.841797%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0.0442505%, 12.644958%, 12.646484%)",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#linear-pattern-0)",
    d: "M 0 0 L 0 3304.558594 L 3268.601562 3304.558594 L 3268.601562 0 Z M 0 0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.88bdf143529da68db61d70177628aa3f.svg";
export { ForwardRef as ReactComponent };